<template>
  <div class="payment">
    <div class="payment-title">
      <span>捐款已成功</span>
      <span>感谢您的爱心</span>
    </div>

    <div class="getCert" @click="goCert()">
      <span>查看证书</span>
    </div>
  </div>
</template>

<script>
import { genLoveCert } from '../../api/index'
import {mapState} from "vuex";
export default {
  name: "payCompleted",
  data(){
    return{
      certimg:''
    }
  },
  computed:{
    ...mapState(['orderId'])
  },
  mounted() {
    //this.getcert()
  },
  methods:{
    async getcert(){
      const data = await genLoveCert({ordId:this.orderId})
      if(data.code == 200){
       this.certimg =data.data.certUrl
      }

    },
    goCert(){
      this.$router.push('/pay')
    }
  }
}
</script>

<style scoped lang="scss">
.payment {
  width: 100%;
  height: 100%;
  background:url('../../assets/completed.jpg');
  background-size: cover;
  color: #FFFFFF;
  text-align: center;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  span{
    font-size: 40px;
    display: block;
    margin-top: 10px;
  }
  .payment-title{
    padding-top: 100px;
  }
  .payment-img{
    width: 100%;
    height:882px;
    img{
      width: 650px;
      height:882px;
      display: block;
      margin: 0 auto;
    }
  }
  .completed{
    width: 300px;
    height: 100px;
    line-height: 100px;
    border-radius:40px;
    background: #A471AA;
    border: 1px solid #FFFFFF;
    font-size: 30px;
    text-align: center;
    margin: 0 auto;
    margin-top: 100px;
    span{
      margin-top: 0;
    }
  }
  .getCert{
    width: 200px;
    margin: 0 auto;
    height: 100px;
    line-height: 100px;
    font-size: 50px;
  }
}
</style>
